import { call, put, takeLatest } from 'redux-saga/effects';
import { setLoading, setProductDetails } from './action';
import { AppAction } from './enum';
import { JarvisProduct } from '../../interface';
import { getJarvisData } from './generator';
import { debugInfo } from '../../util/debug';
import { trackError, trackPageView } from '../../tracking/tracking';

export function* getProductDetailsSaga () {
    yield put(setLoading());

    try {
        const result: JarvisProduct | undefined = yield call(getJarvisData);

        if (!result) {
            return;
        }

        yield put(setProductDetails(result));
        yield call(trackPageView, result);
    } catch (error) {
        yield call(trackError, error);
        yield call(debugInfo, error);
    } finally {
        yield put(setLoading(false));
    }
}

export default function* appSaga () {
    yield takeLatest(AppAction.GET_PRODUCT_DETAILS, getProductDetailsSaga);
}
